import Hook from "../utils/hook"

export default Hook(`ExpandableText`, {
  targets: [`text`, `expand`, `collapse`],
  values: { expandable: Boolean, expanded: Boolean },
  actions: [
    {
      name: `expand`,
      target: `expand`,
      type: `click`,
    },
    {
      name: `collapse`,
      target: `collapse`,
      type: `click`,
    },
  ],

  mounted() {
    if (this.textTarget.offsetHeight >= this.textTarget.scrollHeight)
      this.expandableValue = false
  },

  expandAction() {
    this.expandedValue = true
    if (this.collapseTarget) this.collapseTarget.focus()
  },

  collapseAction() {
    this.expandedValue = false
    if (this.expandTarget) this.expandTarget.focus()
  },
})
